import { Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';
import { Router } from '@angular/router';
import { GraphqlService } from '../../common/services/graphql.service';
import { LoginService } from '../../common/services/Login.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-copyright',
  templateUrl: './copyright.component.html'
})
export class CopyrightComponent implements OnInit {

  constructor(private route: Router,
    private commonDataService: CommonDataService,
    public loginService: LoginService,
    private graphQlService: GraphqlService,
    private sanitizer: DomSanitizer  ) { }
  copyrightHeader;
  copyrightBody;
  clickForInformation;

  ngOnInit(): void {
   
    this.getcopyrightlabels();
  }

  getcopyrightlabels()
  {
    this.graphQlService.getCopyrightLabel().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.copyrightHeader = labels.filter(x => x.key == "copyright_header").map(y => y.value);
        this.copyrightBody = labels.filter(x => x.key == "copyright_subtext").map(y => y.value?.replace("[YEAR_PLACEHOLDER]", new Date().getFullYear()));
        this.clickForInformation =this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "copyright_link").map(y => y.value));
      }
    });
   
  }
 

}
